(function () {
    'use strict';
    var controllerId = 'convDtlEdit';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'dtlId', 'province', 'provinciaId', 'tIndirizzi', 'isSuper', fn_convDtlEdit]);

    function fn_convDtlEdit($scope, datacontext, $uibModalInstance, dtlId, province, provinciaId, tIndirizzi, isSuper) {
        $scope.record = {};
        $scope.province = province;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi; 
        $scope.isSuper = isSuper;

        $scope.change_Comuni = change_Comuni;

        if (dtlId) {
            $scope.dtlId = dtlId;
            getDettaglio();
        }

        if (provinciaId != null) {
            $scope.record.ProvinciaId = provinciaId;
            change_Comuni(provinciaId);
        }
        

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = editItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function editItem(item) {
            console.info('editItem', item);
            return datacontext.cndConvenzioneDtl_merge(item).then(function (data) {
                if (!data)
                    return false;

                return true;
            });
        }

        function getDettaglio() {
            if (!$scope.dtlId || $scope.dtlId == 0) return;
            return datacontext.cndConvenzioneDtl_get($scope.dtlId).then(function (data) {
                console.info('dtl', data);
                if (data) {
                    $scope.record = data
                    getComuni($scope.record.ProvinciaId);
                }
                return $scope.record;
            });
        }

        function change_Comuni(idprov) {
            $scope.record.ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

    }
})();